import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  AfterViewInit,
  ElementRef,
  HostListener,
} from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { FormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { AddressModel } from 'src/app/data/model';
import { AddressService } from 'src/app/services/address.service';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { ResponseHelperService } from 'src/app/services/helpers/response-helper.service';

@Component({
  selector: 'app-address-modal',
  templateUrl: './address-modal.component.html',
  styleUrls: ['./address-modal.component.scss'],
})
export class AddressModalComponent implements OnInit, AfterViewInit {
  @Output() public successEvent: EventEmitter<any> = new EventEmitter();
  @Input() public address: AddressModel = new AddressModel();
  @Input() public partyId: number;
  @Input() public numberOfAddresses: number;
  @Input() public addressData: any;
  allStates: any[] = [];
  title: string;
  isEdit: boolean;
  addressForm: UntypedFormGroup;
  errorMsg: string;
  faTimes = faTimes;
  selectedState: string;
  isDisabledSave: boolean;
  @ViewChild('contry') contry;
  @ViewChild('states') states;
  @ViewChild('statesRef') statesRef: ElementRef;
  @HostListener('document:click', ['$event'])
  onClickOutside(event: MouseEvent) {
    const clickedInside = this.statesRef.nativeElement.contains(event.target);
    if (!clickedInside) {
      this.handleOutsideAutocomplete();
    }
  }
  @HostListener('document:keydown', ['$event'])
  onTabPressed(event: KeyboardEvent) {
    if (event.key === 'Tab') {
      const focusedInside = this.statesRef.nativeElement.contains(
        document.activeElement
      );
      if (!focusedInside) {
        this.handleOutsideAutocomplete();
      }
    }
  }

  constructor(
    private formBuilder: FormBuilder,
    private responseHelperService: ResponseHelperService,
    private addressService: AddressService,
    private modalHelper: NgbModal
  ) {}

  ngAfterViewInit(): void {
    this.contry.close();
  }

  ngOnInit(): void {
    this.addressData.states = this.addressData.states.map((state) => ({
      ...state,
      displayText: `${state.name} (${state.shortName})`,
    }));
    if (this.address.addressId) {
      this.title = 'Edit address';
      this.isEdit = true;
    } else {
      this.title = 'New address';
    }
    this.allStates = [...this.addressData.states];
    this.addressForm = this.formBuilder.group({
      address1: [this.address.address1, Validators.required],
      address2: [this.address.address2],
      city: [this.address.city, Validators.required],
      country: [this.address.country, Validators.required],
      postalCode: [this.address.postalCode, Validators.required],
      state: [this.formatStateCode(this.address.state), Validators.required],
      addressType: [this.address.addressType, Validators.required],
      isPrimary: [this.address.isPrimary],
    });
    this.addressForm.get('country').valueChanges.subscribe((country: any) => {
      if (country) {
        this.addressData.states = this.allStates.filter(
          (state: any) => state.countryCode === country.code
        );
      } else {
        this.addressData.states = [...this.allStates];
      }
    });
    this.selectedState = this.formatStateCode(this.address.state);
  }

  formatStateCode(stateCode: string): string {
    if (stateCode) {
      return stateCode.includes('-') ? stateCode.split('-')[1] : stateCode;
    }
    return stateCode;
  }

  selectCourty(event: any): void {
    this.addressForm.patchValue({ country: event.code });
  }

  ok(): void {
    const value = this.addressForm.value;
    value.partyId = this.partyId;
    if (value.state.code) {
      value.state = this.formatStateCode(value.state.code);
    }
    if (value.state) {
      value.state = this.formatStateCode(value.state);
    }
    if (value.country.code) {
      value.country = value.country.code;
    }
    if (!this.isEdit && this.numberOfAddresses === 0) {
      this.address.isPrimary = true;
    }
    this.addressService
      .createOrUpdateAddresss(this.partyId, this.address.addressId, {
        ...this.address,
        ...value,
      })
      .subscribe(
        () => {
          this.successEvent.emit('success');
        },
        (data: any) => {
          this.responseHelperService.error(this, data.error.error);
        }
      );
  }

  cancel(): void {
    this.modalHelper.dismissAll();
  }

  clearErrorMessage(): void {
    this.errorMsg = '';
  }

  filterByNameAndCode(items: any[], query: string): any[] {
    if (query) {
      query = query.toLocaleLowerCase();
      return items.filter(
        (state: any) =>
          state.name.toLocaleLowerCase().includes(query) ||
          state.code.toLocaleLowerCase().includes(query)
      );
    }
    return items;
  }

  focusStates(): void {
    this.states.close();
  }

  onStateSelected(event: any) {
    const value = this.formatStateCode(event.code);
    this.selectedState = value;
    this.addressForm.patchValue({ state: value });
    this.addressForm.get('state')?.setErrors(null);
  }

  onInputChanged(input: string) {
    this.addressForm.get('state')?.setValue(input);
    this.isDisabledSave = true;
  }

  handleOutsideAutocomplete() {
    const control = this.addressForm.get('state');
    const inputValue = control.value;
    let isValid: boolean;
    if (typeof inputValue === 'string') {
      isValid = !(this.selectedState && inputValue === this.selectedState);
    } else {
      isValid = !(
        this.selectedState &&
        this.formatStateCode(inputValue?.code) === this.selectedState
      );
    }
    if (isValid) {
      control?.setErrors({ invalidState: true });
      control?.markAsTouched();
    } else {
      control?.setErrors(null);
      this.isDisabledSave = false;
    }
  }
}
